import DiscoveryLogin from "@/components/discovery-login";
import { isDev } from "@/lib/utils";
import { useStytchMemberSession } from "@stytch/react/b2b";
import type React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LoginPage: React.FC = () => {
  const { session } = useStytchMemberSession();
  const navigate = useNavigate();

  useEffect(() => {
    // if logged in, redirect to root
    if (session) {
      navigate("/");
    } else if (
      !isDev() &&
      window.location.hostname !== `app.${import.meta.env.VITE_DOMAIN}`
    ) {
      window.location.href = `https://app.${import.meta.env.VITE_DOMAIN}/login`;
    }
  }, [session, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="px-8 py-6 mt-4 text-left bg-white shadow-lg rounded-lg">
        <DiscoveryLogin />
      </div>
    </div>
  );
};

export default LoginPage;
